import styled from 'styled-components'
import { S_FormRow } from '../../../../../../_components/Forms/FormRow'

export const S_ScheduleEsigningContacts = styled.div`
  ${S_FormRow} {
    .form-row-label {
      padding-right: 0px;
      max-width: 130px;
      width: 100%;
    }
  }
`
